import { useEffect, useRef, useState } from "react";
import UseFetch from "../components/UseFetch";
import { Loading, defaulUrl, decryptData, fmt } from "../components/const";
import Paiements from "../Clients/Paiements";
import DetailConteneur from "../Contenaires/DetailConteneur";
import ModalRemboursementFournisseur from "../Comptability/ModalRemboursementFournisseur";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import $ from "jquery"

const FacturesImpayes = () => {
    const user = decryptData('USER');
    const { data: fournisseurs, isloading } = UseFetch('fournisseurs/factures');
    const [selectedFacture, setFacture] = useState(null)
    const [detailproduct, setDetailProduct] = useState([])
    const [isLoading, setIsLoading] = useState(false)
    const [listPaiement, setPaiements] = useState([]);
    const tableRef = useRef(null)
    const printElement = useRef(null)
    const [total, setTotal] = useState(0)
    const [totalPaye, setTotalPaye] = useState(0)
    const [totalDette, setTotalDette] = useState(0)

    const handleSetSelect = (fact) => setFacture(fact);

    const handleDetail = (e, id) => {
        setIsLoading(true)
        e.preventDefault()
        fetch(`${defaulUrl}stocks/liste/${+id}`, {
            method: "GET",
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`
            }
        }).then((response) => response.json())
            .then(data => {
                setIsLoading(false)
                setDetailProduct(data)
            })
    }

    const handleShowPaiements = (e, id) => {
        setIsLoading(true)
        e.preventDefault()
        fetch(`${defaulUrl}conteneur/${id}/paiements`, {
            method: "GET",
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${decryptData('ACCESS_TOKEN')}`
            }
        }).then((response) => response.json())
            .then(data => {
                setIsLoading(false)
                setPaiements(data)
            })
    }

    useEffect(() => {
        setTotal(fournisseurs?.reduce((prev, curr) => prev + curr.montant, 0))
        setTotalPaye(fournisseurs?.reduce((prev, curr) => prev + curr.paye, 0))
        setTotalDette(fournisseurs?.reduce((prev, curr) => prev + curr.reste, 0))
    }, [fournisseurs])

    $(tableRef.current).DataTable();

    // 🔹 Fonction PDF dynamique pour factures impayées
    const printFactures = (title, tab = []) => {
        const user = decryptData("USER");

        if (!tab || tab.length === 0) {
            alert("Aucune donnée à imprimer !");
            return;
        }

        const doc = new jsPDF("landscape");

        // Entête PDF
        doc.setFontSize(18);
        doc.setTextColor(0, 123, 255);
        doc.text("FANSAN TEXTIL", 105, 20, { align: "center" });
        doc.setFontSize(14);
        doc.text(title?.toUpperCase() || "", 105, 30, { align: "center" });

        // Colonnes visibles dans le tableau HTML
        const headers = [
            "N°",
            "N°FACTURE",
            "CONTENEUR",
            "FOURNISSEUR",
            "TELEPHONE",
            "MONTANT TOTAL",
            "MONTANT PAYE",
            "RESTE"
        ];

        const data = tab.map((fourn, index) => [
            index + 1,
            fourn.numero || "",
            fourn.conteneur || "",
            `${fourn.prenoms} ${fourn.nom}` || "",
            fourn.telephone || "",
            fmt(fourn.montant) + (fourn.devise || ""),
            fmt(fourn.paye) + (fourn.devise || ""),
            fmt(fourn.reste) + (fourn.devise || "")
        ]);

        autoTable(doc, {
            startY: 40,
            head: [headers],
            body: data,
            headStyles: { fillColor: [52, 58, 64], textColor: 255 },
            theme: "grid",
        });

        // Pied de page
        const pageHeight = doc.internal.pageSize.height;
        doc.setFontSize(10);
        doc.text(new Date().toLocaleDateString(), 105, pageHeight - 20, { align: "center" });
        doc.text(user?.droit?.toUpperCase() || "", 105, pageHeight - 10, { align: "center" });

        doc.save(`${title || "factures_impayees"}.pdf`);
    }

    return (
        <div className="Factures">
            <div className="row my-2">
                <div className="col-lg-6 h2 text-primary">
                    FACTURES NON PAYEES
                </div>
            </div>
            {isloading ? <Loading /> : fournisseurs?.length ?
                <div className="row">
                    <button className="btn btn-primary m-1 w-auto ms-auto" onClick={() => printFactures("Factures Impayées", fournisseurs)}>
                        <i className="bx bx-printer"></i>
                    </button>
                    <div className="table-responsive p-2" ref={printElement}>
                        <table ref={tableRef} className="table table-hover table-striped table-bordered border-primary text-center">
                            <thead className="table-primary border-primary">
                                <tr>
                                    <th>N°</th>
                                    <th>N°FACTURE</th>
                                    <th>CONTENEUR</th>
                                    <th>FOURNISSEUR</th>
                                    <th>TELEPHONE</th>
                                    <th>MONTANT TOTAL</th>
                                    <th>MONTANT PAYE</th>
                                    <th>RESTE</th>
                                    <th className="text-end">ACTIONS</th>
                                </tr>
                            </thead>
                            <tbody className="plage">
                                {fournisseurs.map((fourn, index) => (
                                    <tr key={index} className="tr">
                                        <td>{index + 1}</td>
                                        <td>{fourn.numero}</td>
                                        <td>{fourn.conteneur}</td>
                                        <td>{`${fourn.prenoms} ${fourn.nom}`}</td>
                                        <td>{fourn.telephone}</td>
                                        <td>{`${(+fourn.montant).toLocaleString()} ${fourn.devise}`}</td>
                                        <td>{`${(+fourn.paye).toLocaleString()} ${fourn.devise}`}</td>
                                        <td>{`${(+fourn.reste).toLocaleString()} ${fourn.devise}`}</td>
                                        <td className="text-end">
                                            {user.droit === 'Comptable' && <button className="btn btn-success m-1" data-bs-toggle="modal" data-bs-target="#modalRemboursementFournisseur" onClick={() => handleSetSelect(fourn)}><i className="bx bx-dollar-circle"></i></button>}
                                            <button className="btn btn-primary m-1" data-bs-toggle="modal" data-bs-target="#paiement" onClick={(e) => handleShowPaiements(e, fourn.idcont)}><i className="bx bx-task"></i></button>
                                            <button className="btn btn-info m-1" data-bs-toggle="modal" data-bs-target="#detailConteneur" onClick={(e) => handleDetail(e, fourn.idcont)}><i className="bx bx-show text-white"></i></button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
                :
                <div className="row justify-content-center p-2 bg-danger-subtle text-danger fs-5">
                    Aucun fournisseur trouvé!
                </div>
            }

            <ModalRemboursementFournisseur facture={selectedFacture} table='conteneur' />
            <Paiements paiements={listPaiement} isLoading={isLoading} />
            <DetailConteneur isLoading={isLoading} detailproduct={detailproduct} />
        </div>
    );
}

export default FacturesImpayes;
